import roles from '@/security/roles';
import { clearAllCookie } from '@/utils';
import { Avatar, Dropdown } from 'antd';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { history, useModel } from 'umi';

const menuKeys = {
  user: 'user',
  password: 'password',
  signout: 'signout',
};

const RightContent: React.FC = () => {
  const { login, isAuth } = useModel('login');

  const getLabel = (label: ReactNode) => <div className="px-6 py-1">{label}</div>;

  const items: any[] = [
    isAuth([roles.admin]) && {
      key: menuKeys.user,
      label: getLabel('用户管理'),
    },
    {
      key: menuKeys.password,
      label: getLabel('修改密码'),
    },
    { type: 'divider' },
    {
      key: menuKeys.signout,
      label: getLabel('退出登录'),
    },
  ].filter(Boolean);

  const mineMethods = {
    [menuKeys.user]: () => history.push('/users'),
    [menuKeys.password]: () => history.push('/users/edit_password'),
    [menuKeys.signout]: () => {
      localStorage.clear();
      clearAllCookie();
      history.replace('/users/sign_in');
    },
  };

  return (
    <div className={classNames('flex items-center')}>
      <Dropdown
        menu={{
          items,
          selectedKeys: [],
          onClick: ({ key }) => mineMethods[key]?.(),
        }}
      >
        <Avatar className="cursor-pointer bg-primary">{login?.user?.name?.slice(-2)}</Avatar>
      </Dropdown>
    </div>
  );
};

export default RightContent;
